<script lang="ts">
  import CardCarousel from "@shared/svelte/Components/Carousel/CardCarousel.svelte";
  import NoProductAvailable from "@shared/svelte/Components/NoProductAvailable.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { CustomContentProductCarouselEntity } from "@shared/services/event_tracking/entities";

  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { compact } from "lodash";

  import type { ProductLine } from "@shared/types/ProductLine";

  export let productLineIds: number[];
  export let id: number;
  export let position: number;
  export let title: string;
  export let productLinesApiUrl: string = "/api/retailer/product_lines";
  export let carouselCardsShown: number = 5;

  // Unused props passed from discovery panel
  export let mobileMode: boolean = false;
  mobileMode;

  let loaded = false;
  let productLines: ProductLine[] = [];
  const options = {
    method: "GET",
    url: productLinesApiUrl,
    data: {
      ids: productLineIds,
    },
  };

  if (productLineIds.length) {
    HttpPromise(options).then(res => {
      // Order the product lines in the same order they are configured to be in
      productLines = compact(
        productLineIds.map(id => res.find(r => r?.id && parseInt(r.id) === id))
      );
      loaded = true;
    });
  }

  const trackingEntity = new CustomContentProductCarouselEntity({ id, position });

</script>

<TrackingContext entities={trackingEntity}>
  {#key productLineIds}
    <div class="fizz-styles" data-testid="custom-content-product-carousel">
      {#if loaded}
        {#if productLines.length}
          <div class="fizz-container">
            <CardCarousel
              {carouselCardsShown}
              carouselIdentifier={`custom-content-product-carousel-position-${position}`}
              carouselName={title}
              outsideContainer={true}
              {productLines}
            />
          </div>
        {:else}
          <NoProductAvailable {title} />
        {/if}
      {/if}
    </div>
  {/key}
</TrackingContext>
